import { useQueryGetItemAvailabilityById } from '@flecto/core/store'
import { type CoreItem } from '@flecto/types'

import { useStoreDates } from './useStoreDates'
import { useStoreDetails } from './useStoreDetails'
import { useStoreItemAvailabilityMerge } from './useStoreItemAvailabilityMerge'

export type UseStoreItemAvailabilityOptions = {
  item?: CoreItem
  quantityToAdd?: number
}

export function useStoreItemAvailability({
  item: paramItem,
  quantityToAdd,
}: UseStoreItemAvailabilityOptions) {
  const { startAt, endAt } = useStoreDates()
  const store = useStoreDetails()

  const { data: itemAvailability, isFetching } =
    useQueryGetItemAvailabilityById({
      storeDomain: store?.domain,
      itemId: paramItem?.id,
      options: {
        quantity: quantityToAdd,
        start_at: startAt ?? '',
        end_at: endAt ?? '',
      },
    })

  const item = useStoreItemAvailabilityMerge({
    item: paramItem,
    itemAvailability,
    quantityToAdd,
    startAt,
    endAt,
  })

  return {
    item,
    isLoading: isFetching,
  }
}
